namespace GeniuzPOS.Product {
    export interface ReportExportV1Form {
        Category: Serenity.LookupEditor;
        Subcategory1: Serenity.LookupEditor;
        Subcategory2: Serenity.LookupEditor;
        BrandId: Serenity.LookupEditor;
        StyleId: Serenity.LookupEditor;
        ColorId: Serenity.LookupEditor;
        SizeId: Serenity.LookupEditor;
        TasteId: Serenity.LookupEditor;
        MatTypeId: Serenity.LookupEditor;
        SkuDesc: Serenity.StringEditor;
        PluDesc: Serenity.StringEditor;
        SupplId: Serenity.StringEditor;
        SupplItemCode: Serenity.StringEditor;
        StkUnit: Serenity.StringEditor;
        PurUnit: Serenity.StringEditor;
        PurUnitRatio: Serenity.DecimalEditor;
        StockFg: Serenity.IntegerEditor;
        VatType: Serenity.StringEditor;
        VatCode: Serenity.StringEditor;
        MinStockQty: Serenity.DecimalEditor;
        MaxStockQty: Serenity.DecimalEditor;
        PurLeadTime: Serenity.DecimalEditor;
        ConsignFg: Serenity.IntegerEditor;
        ConsignGp: Serenity.DecimalEditor;
        NonAllowtoDiscountFg: Serenity.IntegerEditor;
        CusProductTypeNbp: Serenity.StringEditor;
        CusProductSalesBeforeFlag: Serenity.StringEditor;
        CusProductSalesBeforeReferFlag: Serenity.StringEditor;
        CusProductSalesBeforeRefer: Serenity.StringEditor;
        SellUnitPrice1: Serenity.DecimalEditor;
        SellUnitPrice2: Serenity.DecimalEditor;
        SellUnitPrice3: Serenity.DecimalEditor;
        SellUnitPrice4: Serenity.DecimalEditor;
        SellUnitPrice5: Serenity.DecimalEditor;
        SellUnitPrice6: Serenity.DecimalEditor;
        PurUnitPrice: Serenity.DecimalEditor;
        DeliverCost: Serenity.DecimalEditor;
        SetItemFg: Serenity.IntegerEditor;
        ProductCpDesc1: Serenity.StringEditor;
        ProductCpDesc2: Serenity.StringEditor;
        ProductCpComponent: Serenity.StringEditor;
        ProductCpHowToUse: Serenity.StringEditor;
        ProductCpWarning: Serenity.StringEditor;
        CreateDate: Serenity.DateEditor;
        CreateBy: Serenity.StringEditor;
    }

    export class ReportExportV1Form extends Serenity.PrefixedContext {
        static formKey = 'Product.ReportExportV1';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportExportV1Form.init)  {
                ReportExportV1Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DateEditor;

                Q.initFormType(ReportExportV1Form, [
                    'Category', w0,
                    'Subcategory1', w0,
                    'Subcategory2', w0,
                    'BrandId', w0,
                    'StyleId', w0,
                    'ColorId', w0,
                    'SizeId', w0,
                    'TasteId', w0,
                    'MatTypeId', w0,
                    'SkuDesc', w1,
                    'PluDesc', w1,
                    'SupplId', w1,
                    'SupplItemCode', w1,
                    'StkUnit', w1,
                    'PurUnit', w1,
                    'PurUnitRatio', w2,
                    'StockFg', w3,
                    'VatType', w1,
                    'VatCode', w1,
                    'MinStockQty', w2,
                    'MaxStockQty', w2,
                    'PurLeadTime', w2,
                    'ConsignFg', w3,
                    'ConsignGp', w2,
                    'NonAllowtoDiscountFg', w3,
                    'CusProductTypeNbp', w1,
                    'CusProductSalesBeforeFlag', w1,
                    'CusProductSalesBeforeReferFlag', w1,
                    'CusProductSalesBeforeRefer', w1,
                    'SellUnitPrice1', w2,
                    'SellUnitPrice2', w2,
                    'SellUnitPrice3', w2,
                    'SellUnitPrice4', w2,
                    'SellUnitPrice5', w2,
                    'SellUnitPrice6', w2,
                    'PurUnitPrice', w2,
                    'DeliverCost', w2,
                    'SetItemFg', w3,
                    'ProductCpDesc1', w1,
                    'ProductCpDesc2', w1,
                    'ProductCpComponent', w1,
                    'ProductCpHowToUse', w1,
                    'ProductCpWarning', w1,
                    'CreateDate', w4,
                    'CreateBy', w1
                ]);
            }
        }
    }
}
